module.exports = __webpack_public_path__ + "static/media/MarblingPreview.22b865cb.gif";